<div class="modify-pickup extend-page">

  <div class="row m-0">
    <div class="col-lg-5 col-md-6 left-modal-side">
      <div class="left-modal-side-padding">
        <h3 mat-dialog-title >{{  'ExtendRentalTime' | translate  }}</h3>
        <div *ngIf="!needPayment" class="search-Form-modal">
            <p>
              {{ 'DefineTheNewReturnDateAndTime' | translate }}:
            </p>
            <div class="search-Form-modal mt-3">
              <form [formGroup]="searchForm" (ngSubmit)="onExtend()">


                <!--Drop-off-->
                <section class="drop-off row">
                  <div class="col-md-12 row">
                    <label class="col-lg-3 col-md-3">{{ 'Return' | translate }}</label>
                    <div class="col-lg-9 col-md-9">
                      <div class="form-group">
                        <div  class="input-group">
                          <span class="input-group-prepend disable-text">
                              <span class="input-group-text disable-text">
                                  <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                              </span>
                          </span>
  <!--                          <input ngx-google-places-autocomplete [options]='options' formControlName="location"
                          class="form-control"
                          #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)"
                          [ngClass]="{ 'is-invalid': submitted  }"
                          />-->
                        <mat-select panelClass="select-return"  class="form-control select"

                        formControlName="location"
                        [ngClass]="{'is-invalid':searchForm.get('location').touched && searchForm.get('location').invalid}" required
                        data-placeholder="Select">
                        <mat-option *ngFor="let dropUpLocation of dropUpLocations" [value]="dropUpLocation.returnAgencyID">
                          {{dropUpLocation.agencyReturnLocationName | translate}}</mat-option>
                      </mat-select>


                        </div>



                      </div>
                      <div class="row">
                        <div class="col-md-6 pr-0">
                          <div class="form-group">
                            <div class="drop-off-date">
                              <mat-form-field appearance="none">
                                  <mat-datepicker-toggle matPrefix [for]="endDate"></mat-datepicker-toggle>
                                  <mat-datepicker #endDate></mat-datepicker>
                                  <input readonly placeholder=" "  formControlName="endDate" matInput [min]="minDropOffDate"
                                  (dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)"
                                  [matDatepicker]="endDate" (click)="endDate.open()">
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 pl-2">
                          <div class="form-group">
                            <div class="drop-off-time">
                              <fa-icon class="time-icon" [icon]="faClock"></fa-icon>
                              <input placeholder="12:00am" formControlName="endTime" id="endTime" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-3">
                        <button class="btn default-btn btn-extend mr-2 mb-2" mat-button>{{ 'CheckAvailability' | translate }}</button>
                        <button (click)="cancelClicked()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </section>

              </form>
            </div>

            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-9 pl-md-2">
                <div *ngIf="success">
                  <div class="success text-blue">
                    <mat-icon class="text-blue mr-2 ">insert_emoticon</mat-icon> {{ 'GreatRentalisAvailable' | translate }}

                  </div>
                  <div class="bg-grey-extend mb-3">
                    <div class="mb-2">{{ 'PriceforEXTENDPERIOD' | translate }}   <span class="period">{{result.durationInDaysNewDuration}}</span></div>
                    <div class="vehicle-price mb-3">{{result.totalRentalDuration | number : '1.2-2'}} {{currency}}</div>
                    <div class="mb-2">{{ 'TotalCharges' | translate }}  <span class="period">{{result.totalDurationInDays}}</span></div>
                    <div class="vehicle-price mb-0" *ngIf="currentTotalCharge!=null&&totalCharges!=null">{{totalCharges-currentTotalCharge | number : '1.2-2'}} {{currency}}</div>
                  </div>
                  <div class="text-left">
                    <button (click)="confirmExtend()"  class="btn default-btn mr-3" mat-button>{{ 'Confirm' | translate }}</button>
                  </div>
                </div>
                <div *ngIf="notAvailable">
                  <div class="not-available">
                    <div class="border-danger-title bg-grey d-flex  mb-3">
                      <div><mat-icon>warning</mat-icon></div>
                      <div *ngIf="notAvailableReason==NotAvailableReasonEnum.NotAvailablePeriod">
                        <p class="ml-3">{{ 'Sorry' | translate }}</p>
                        <span>{{ 'BookedRentalisNotAvailable' | translate }}</span>
                      </div>
                      <div *ngIf="notAvailableReason==NotAvailableReasonEnum.ReturnLocationIsNotAvailable">
                        <p class="ml-3">{{ 'Sorry' | translate }}</p>
                        <span>{{ 'ReturnLocationNotAvailable' | translate }}</span>
                      </div>
                      <div *ngIf="notAvailableReason==NotAvailableReasonEnum.VehicleNotAvailble">
                        <p class="ml-3">{{ 'Sorry' | translate }}</p>
                        <span>{{ 'VehicleNotAvailble' | translate }}</span>
                      </div>
                      <div *ngIf="notAvailableReason==NotAvailableReasonEnum.ExpiredIdntity">
                        <p class="ml-3">{{ 'Sorry' | translate }}</p>
                        <span>{{ 'notAvailableReasonExpiredIdntity' | translate }}</span>
                      </div>
                      <div *ngIf="notAvailableReason==NotAvailableReasonEnum.UnavailableAdditional">
                        <p class="ml-3">{{ 'Sorry' | translate }}</p>
                        <span>{{ 'UnavailableAdditional' | translate }}</span>
                        <!-- List of Unavailable Additional-->
                        <div>
                          <span *ngFor="let service of result.lstUnavailableAdditionalServiceReservationCaseModel">{{service.serviceName}} <span *ngIf="service.numberOfUnavailable!=null&&service.numberOfUnavailable>0">({{service.numberOfUnavailable}})</span> </span>
                        </div>

                      </div>
                    </div>
                    <div class="text-left">
                      <button (click)="cancelChange()"  class="btn default-btn mr-3" mat-button>{{ 'CancelChange' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div class="d-flex post-back-msg mt-4" *ngIf="isDropOffSameAsPickUp">
                  <div class="d-flex justify-content-center align-items-center"><i class="fas fa-exclamation-circle mr-2 fa-2x"></i></div>
                  <div class="d-flex justify-content-center align-items-center">{{"Pleaseselectatime,dategreaterthantheoldreturndate" | translate}}.
                  </div>
                </div>
              </div>
            </div>





            <!-- <div *ngIf="isDropOffSameAsPickUp">
              <span>Please select a time, date greater than the old return date.</span>
            </div> -->


        </div>
        <payment-edit *ngIf="needPayment"
        [requiredPayment]="requiredPayment"
        [extendpayment]="true"
        [objPayment]="objPayment"
        [vehicleReservationCaseResult]="vehicleReservationCaseResult"
        (onCancel)="changeViewType()"
        ></payment-edit>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 modal-card">
      <vehicle-card-for-modal [vehicle]="vehicle"></vehicle-card-for-modal>
    </div>
    <div class="col-lg-4 col-md-12 modify-booking-charge-summary">

      <div class="">
        <!--charge summery view-->
        <charge-summary-view-booking  [newDurationExtendData]="newDurationData" [unavailableAditionalServiceData]="unavailableAditionalServiceData" (onTotalCalculated)="onTotalCalculated($event)" ></charge-summary-view-booking><!-- [oneWayRentalServiceData]="oneWayRentalServiceData""-->
        <!-- <charge-summary></charge-summary> -->
      </div>
    </div>
  </div>
</div>

